// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';

import Icon_trustpilot from '../../../img/trustpilot_micro.svg';
import {use_theme} from '../../../../../hola/pub/settings_ctx';
import Icon_tick from '../../../img/tick_round.svg';

import styles from './trustpilot.module.less';

type t_trustpilot_props = {
    cls?: string;
    no_logo?: boolean;
    features: string[];
};

export const Trustpilot = ({cls, no_logo, features}: t_trustpilot_props)=>{
    const {theme} = use_theme();
    const root_cls = cn(cls, styles.trustpilot, no_logo && styles.no_logo);
    return <div className={root_cls}>
      {!no_logo && <a href="https://www.trustpilot.com/review/toolip.io"
        target="_blank" rel="noopener noreferrer">
        <Icon_trustpilot />
      </a>}
      <div className={styles.features}>
        {features.length > 1 && features.map(feature=>{
          return <p className={cn(styles.feature, theme.p3)} key={feature}>
            <Icon_tick />{feature}
          </p>;
        })}
      </div>
    </div>;
};
